import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import axios from "axios";
import "react-big-calendar/lib/css/react-big-calendar.css";
import NotificationCalendar from "./NotificationCalendar";
import Serverurl from './Apiurl';
import {
 Typography, TextField,
} from '@mui/material';

const localizer = momentLocalizer(moment);

export default class ReactBigCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventsData: [],
      showNotificationPopup: false,
      selectedDate: null,
      editingNotification: null,
      currentDate: new Date(),currentView: "month",
    };
  }

  componentDidMount() {
    document.title = "Notification";
    this.loadNotifications();
  }

  loadNotifications = () => {
    axios
      .get(Serverurl+"notifications/getall", {
        params: { page: 0, limit: 50 },
      })
      .then((response) => {
   const events = response.data.data.map((item) => {
  const startDate = item.nt_date ? new Date(item.nt_date) : null;
  const endDate = startDate ? new Date(startDate.getTime() + 60 * 60 * 1000) : startDate; // 1 hour later
  return {
    title: item.nt_title,
    start: startDate,
    end: endDate,
    raw: item,
  };
});
        this.setState({ eventsData: events });
      })
      .catch((err) => {});
  };

  isPastDate = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  };

  handleSelectSlot = ({ start }) => {
    if (this.isPastDate(start)) return;
    this.setState({
      showNotificationPopup: true,
      selectedDate: start,
      editingNotification: null,
    });
  };

  handleSelectEvent = (event) => {
    if (this.isPastDate(event.start)) return;
    this.setState({
      showNotificationPopup: true,
      selectedDate: event.start,
      editingNotification: event.raw,
    });
  };

  handleClosePopup = () => {
    this.setState({
      showNotificationPopup: false,
      selectedDate: null,
      editingNotification: null,
    });
  };

  handleNotificationAdded = () => {
    this.loadNotifications();
    this.handleClosePopup();
  };

  handleNavigate = (date) => {
    this.setState({ currentDate: date });
  };

  handleViewChange = (view) => {
  this.setState({ currentView: view });
};

  customDayPropGetter = (date) => {
    if (this.isPastDate(date)) {
      return {
        className: "rbc-day-disabled",
      };
    }
    return {};
  };

  EventComponent = ({ event }) => {
    return (
      <div
        style={{
          backgroundColor: "#86bd43",
          color: "white",
          fontSize: "1em",
          padding: "2px 0",
          cursor: "pointer",
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
      >
        {event.title}
      </div>
    );
  };

  render() {
    return (
		  	  <div className="maincontentDiv">
      <div className="calendar-container">
		  <Typography pt={2} pb={2} className="contentHeading" variant="h5">Notifications</Typography>

        <Calendar
          selectable
          localizer={localizer}
          events={this.state.eventsData}
          views={["month", "week","day"]}
          defaultView="month"
          style={{ height: "80vh" }}
          dayPropGetter={this.customDayPropGetter}
          onSelectEvent={this.handleSelectEvent}
          onSelectSlot={this.handleSelectSlot}
          date={this.state.currentDate}
          onNavigate={this.handleNavigate}
		  view={this.state.currentView}
  onView={this.handleViewChange}
          popup 
          components={{
            event: this.EventComponent,
          }}
          formats={{
            eventTimeRangeFormat: () => "", 
            agendaTimeRangeFormat: () => "",
          }}
        />

        {this.state.showNotificationPopup && (
          <NotificationCalendar
            open={this.state.showNotificationPopup}
            date={this.state.selectedDate}
            notification={this.state.editingNotification}
            onClose={this.handleClosePopup}
            onNotificationAdded={this.handleNotificationAdded}
          />
        )}
      </div>
      </div>
    );
  }
}
